module.exports = __webpack_public_path__ + "static/logo-21fdef3a241a719aaffc2b926c92f58c.png";